/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */
import * as Types from '../../../../../types/dashboard-core-gqlTypes.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type ApiKeyWithOrganizationFragmentGQLType = (
  { __typename?: 'ApiKeyWithOrganization' }
  & Pick<Types.ApiKeyWithOrganizationGQLType, 'actorType' | 'id' | 'key' | 'secret' | 'description' | 'created_at' | 'updated_at' | 'isActive' | 'userId' | 'organizationId' | 'organizationName' | 'organizationSlug'>
);

export type FinleyAutomatedFragmentGQLType = (
  { __typename?: 'FinleyAutomated' }
  & Pick<Types.FinleyAutomatedGQLType, 'actorType' | 'id' | 'name'>
);

export type UnknownActorFragmentGQLType = (
  { __typename?: 'UnknownActor' }
  & Pick<Types.UnknownActorGQLType, 'actorType' | 'id' | 'originalActorType' | 'name'>
);

export type UserActorFragmentGQLType = (
  { __typename?: 'UserActor' }
  & Pick<Types.UserActorGQLType, 'actorType' | 'id' | 'email' | 'userType' | 'organizationId' | 'isActive' | 'roleType' | 'firstName' | 'lastName'>
);

export type FundingRequestPayloadFragmentGQLType = (
  { __typename?: 'FundingRequestPayload' }
  & { fundingRequest: (
    { __typename?: 'FundingRequest' }
    & Pick<Types.FundingRequestGQLType, 'id' | 'creditFacilityName'>
  ) }
);

export type FundingRequestComponentPayloadFragmentGQLType = (
  { __typename?: 'FundingRequestComponentPayload' }
  & { fundingRequest: (
    { __typename?: 'FundingRequest' }
    & Pick<Types.FundingRequestGQLType, 'id' | 'creditFacilityName'>
  ), fundingRequestComponent: (
    { __typename?: 'FundingRequestComponent' }
    & Pick<Types.FundingRequestComponentGQLType, 'amount' | 'type'>
  ) }
);

export type DeliverablesPayloadFragmentGQLType = (
  { __typename?: 'DeliverablesPayload' }
  & { deliverableItem: (
    { __typename?: 'DeliverableItem' }
    & Pick<Types.DeliverableItemGQLType, 'creditFacilityName' | 'status'>
  ) }
);

export type InsertedDeliverablePayloadFragmentGQLType = (
  { __typename?: 'InsertedDeliverablePayload' }
  & { deliverable: (
    { __typename?: 'DeliverablePayload' }
    & Pick<Types.DeliverablePayloadGQLType, 'id' | 'creditFacilityName' | 'status' | 'updated_at'>
  ) }
);

export type UpdatedDeliverableStatusPayloadFragmentGQLType = (
  { __typename?: 'UpdatedDeliverableStatusPayload' }
  & { deliverable: (
    { __typename?: 'DeliverablePayload' }
    & Pick<Types.DeliverablePayloadGQLType, 'id' | 'creditFacilityName' | 'status' | 'updated_at'>
  ) }
);

export type SubmittedDeliverableSubmissionPayloadFragmentGQLType = (
  { __typename?: 'SubmittedDeliverableSubmissionPayload' }
  & { deliverable: (
    { __typename?: 'DeliverablePayload' }
    & Pick<Types.DeliverablePayloadGQLType, 'id' | 'creditFacilityName' | 'status' | 'updated_at'>
  ) }
);

export type IngestionPayloadFragmentGQLType = (
  { __typename?: 'IngestionPayload' }
  & Pick<Types.IngestionPayloadGQLType, 'origin' | 'failedOps' | 'successOps' | 'messages'>
);

export type VerificationPayloadFragmentGQLType = (
  { __typename?: 'VerificationPayload' }
  & Pick<Types.VerificationPayloadGQLType, 'verificationReportId' | 'creditFacilityName'>
);

export type EventForRenderFragmentGQLType = (
  { __typename?: 'EventWithActor' }
  & Pick<Types.EventWithActorGQLType, 'id' | 'domainKey' | 'actionKey' | 'actorName' | 'targetName' | 'created_at' | 'isCapitalProvider'>
  & { payload: (
    { __typename?: 'FundingRequestPayload' }
    & FundingRequestPayloadFragmentGQLType
  ) | (
    { __typename?: 'FundingRequestComponentPayload' }
    & FundingRequestComponentPayloadFragmentGQLType
  ) | (
    { __typename?: 'DeliverablesPayload' }
    & DeliverablesPayloadFragmentGQLType
  ) | (
    { __typename?: 'IngestionPayload' }
    & IngestionPayloadFragmentGQLType
  ) | (
    { __typename?: 'InsertedDeliverablePayload' }
    & InsertedDeliverablePayloadFragmentGQLType
  ) | (
    { __typename?: 'UpdatedDeliverableStatusPayload' }
    & UpdatedDeliverableStatusPayloadFragmentGQLType
  ) | (
    { __typename?: 'SubmittedDeliverableSubmissionPayload' }
    & SubmittedDeliverableSubmissionPayloadFragmentGQLType
  ) | (
    { __typename?: 'VerificationPayload' }
    & VerificationPayloadFragmentGQLType
  ) }
);

export type GetEventsQueryVariablesGQLType = Types.Exact<{
  organizationId: Types.Scalars['String'];
  limit: Types.Scalars['Int'];
  after?: Types.Maybe<Types.Scalars['String']>;
  before?: Types.Maybe<Types.Scalars['String']>;
  startDate?: Types.Maybe<Types.Scalars['FullDateStr']>;
  endDate?: Types.Maybe<Types.Scalars['FullDateStr']>;
}>;


export type GetEventsQueryGQLType = (
  { __typename?: 'Query' }
  & { events: (
    { __typename?: 'EventConnection' }
    & Pick<Types.EventConnectionGQLType, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<Types.PageInfoGQLType, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ), nodes: Array<(
      { __typename?: 'EventWithActor' }
      & EventForRenderFragmentGQLType
    )> }
  ) }
);

export const ApiKeyWithOrganizationFragmentDocGQLType = gql`
    fragment ApiKeyWithOrganization on ApiKeyWithOrganization {
  actorType
  id
  key
  secret
  description
  created_at
  updated_at
  isActive
  userId
  organizationId
  organizationName
  organizationSlug
}
    `;
export const FinleyAutomatedFragmentDocGQLType = gql`
    fragment FinleyAutomated on FinleyAutomated {
  actorType
  id
  name
}
    `;
export const UnknownActorFragmentDocGQLType = gql`
    fragment UnknownActor on UnknownActor {
  actorType
  id
  originalActorType
  name
}
    `;
export const UserActorFragmentDocGQLType = gql`
    fragment UserActor on UserActor {
  actorType
  id
  email
  userType
  organizationId
  isActive
  roleType
  firstName
  lastName
}
    `;
export const FundingRequestPayloadFragmentDocGQLType = gql`
    fragment FundingRequestPayload on FundingRequestPayload {
  fundingRequest {
    id
    creditFacilityName
  }
}
    `;
export const FundingRequestComponentPayloadFragmentDocGQLType = gql`
    fragment FundingRequestComponentPayload on FundingRequestComponentPayload {
  fundingRequest {
    id
    creditFacilityName
  }
  fundingRequestComponent {
    amount
    type
  }
}
    `;
export const DeliverablesPayloadFragmentDocGQLType = gql`
    fragment DeliverablesPayload on DeliverablesPayload {
  deliverableItem {
    creditFacilityName
    status
  }
}
    `;
export const InsertedDeliverablePayloadFragmentDocGQLType = gql`
    fragment InsertedDeliverablePayload on InsertedDeliverablePayload {
  deliverable {
    id
    creditFacilityName
    status
    updated_at
  }
}
    `;
export const UpdatedDeliverableStatusPayloadFragmentDocGQLType = gql`
    fragment UpdatedDeliverableStatusPayload on UpdatedDeliverableStatusPayload {
  deliverable {
    id
    creditFacilityName
    status
    updated_at
  }
}
    `;
export const SubmittedDeliverableSubmissionPayloadFragmentDocGQLType = gql`
    fragment SubmittedDeliverableSubmissionPayload on SubmittedDeliverableSubmissionPayload {
  deliverable {
    id
    creditFacilityName
    status
    updated_at
  }
}
    `;
export const IngestionPayloadFragmentDocGQLType = gql`
    fragment IngestionPayload on IngestionPayload {
  origin
  failedOps
  successOps
  messages
}
    `;
export const VerificationPayloadFragmentDocGQLType = gql`
    fragment VerificationPayload on VerificationPayload {
  verificationReportId
  creditFacilityName
}
    `;
export const EventForRenderFragmentDocGQLType = gql`
    fragment EventForRender on EventWithActor {
  id
  domainKey
  actionKey
  actorName
  targetName
  created_at
  isCapitalProvider
  payload {
    ... on FundingRequestPayload {
      ...FundingRequestPayload
    }
    ... on FundingRequestComponentPayload {
      ...FundingRequestComponentPayload
    }
    ... on DeliverablesPayload {
      ...DeliverablesPayload
    }
    ... on InsertedDeliverablePayload {
      ...InsertedDeliverablePayload
    }
    ... on UpdatedDeliverableStatusPayload {
      ...UpdatedDeliverableStatusPayload
    }
    ... on SubmittedDeliverableSubmissionPayload {
      ...SubmittedDeliverableSubmissionPayload
    }
    ... on IngestionPayload {
      ...IngestionPayload
    }
    ... on VerificationPayload {
      ...VerificationPayload
    }
  }
}
    ${FundingRequestPayloadFragmentDocGQLType}
${FundingRequestComponentPayloadFragmentDocGQLType}
${DeliverablesPayloadFragmentDocGQLType}
${InsertedDeliverablePayloadFragmentDocGQLType}
${UpdatedDeliverableStatusPayloadFragmentDocGQLType}
${SubmittedDeliverableSubmissionPayloadFragmentDocGQLType}
${IngestionPayloadFragmentDocGQLType}
${VerificationPayloadFragmentDocGQLType}`;
export const GetEventsDocumentGQLType = gql`
    query GetEvents($organizationId: String!, $limit: Int!, $after: String, $before: String, $startDate: FullDateStr, $endDate: FullDateStr) {
  events(
    organizationId: $organizationId
    limit: $limit
    after: $after
    before: $before
    startDate: $startDate
    endDate: $endDate
  ) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    nodes {
      ...EventForRender
    }
  }
}
    ${EventForRenderFragmentDocGQLType}`;

/**
 * __useGetEventsQuery__
 *
 * To run a query within a React component, call `useGetEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetEventsQuery(baseOptions: Apollo.QueryHookOptions<GetEventsQueryGQLType, GetEventsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventsQueryGQLType, GetEventsQueryVariablesGQLType>(GetEventsDocumentGQLType, options);
      }
export function useGetEventsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetEventsQueryGQLType, GetEventsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventsQueryGQLType, GetEventsQueryVariablesGQLType>(GetEventsDocumentGQLType, options);
        }
export type GetEventsQueryHookResult = ReturnType<typeof useGetEventsQuery>;
export type GetEventsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetEventsLazyQueryGQLType>;
export type GetEventsQueryResultGQLType = Apollo.QueryResult<GetEventsQueryGQLType, GetEventsQueryVariablesGQLType>;